// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".face[data-v-0b6ddd17] {\n  fill: #fff;\n}\n.cheeks[data-v-0b6ddd17] {\n  fill: rgba(0, 0, 0, 0.15);\n}\n.nose[data-v-0b6ddd17] {\n  fill: none;\n  stroke: #000;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 8px;\n}\n.lips[data-v-0b6ddd17] {\n  fill: #000;\n}\n.white[data-v-0b6ddd17] {\n  fill: #fff;\n}\n.black[data-v-0b6ddd17] {\n  fill: #000;\n}\n", ""]);
// Exports
module.exports = exports;
